"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactCommunicationDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const contact_entity_1 = require("./contact.entity");
let ContactCommunicationDetails = class ContactCommunicationDetails {
};
exports.ContactCommunicationDetails = ContactCommunicationDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], ContactCommunicationDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ContactCommunicationDetails.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "communication_type",
        type: "varchar",
        length: 50,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], ContactCommunicationDetails.prototype, "communicationType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "communication_details",
        type: "varchar",
        length: 255,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], ContactCommunicationDetails.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_primary", type: "boolean", default: false }),
    tslib_1.__metadata("design:type", Boolean)
], ContactCommunicationDetails.prototype, "isPrimary", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], ContactCommunicationDetails.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], ContactCommunicationDetails.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ContactCommunicationDetails.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], ContactCommunicationDetails.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], ContactCommunicationDetails.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.communicationDetails, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], ContactCommunicationDetails.prototype, "contact", void 0);
exports.ContactCommunicationDetails = ContactCommunicationDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)("contact_communication_details")
], ContactCommunicationDetails);
